<template>
    <el-dialog class="el-dialogs" :title="title" width="400px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="100px">
            <el-form-item label="标注名称：" prop="labelName">
                <el-input v-model.trim="searchForm.labelName" maxlength="20"
                          placeholder="请输入标注名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="标注时间：" prop="createDate">
                <div>{{ searchForm.createDate }}</div>
            </el-form-item>
            <el-form-item label="标注状态：" prop="labeState">
                <div>{{ $dictUtils.getDictLabel("labe_state", searchForm.labeState, '') }}</div>
            </el-form-item>
            <el-form-item label="标注资源：" prop="resourcesName">
                <el-link type="primary" @click="view()">{{ searchForm.resourcesName }}</el-link>
<!--                <el-popover-->
<!--                        placement="right"-->
<!--                        trigger="hover">-->
<!--                    <div class="flex_l_t">-->
<!--                        <el-image-->
<!--                                style="width: 100px; height: 100px"-->
<!--                                :src="'https://img2.baidu.com/it/u=1337068678,3064275007&fm=253&fmt=auto&app=120&f=JPEG?w=500&h=750'"-->
<!--                                :fit="'fill'"></el-image>-->
<!--                        <div style="width: 150px;margin-left: 5px">-->
<!--                            <el-tag v-for="item in 4" :key="item" size="medium">标签</el-tag>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="text_center">-->
<!--                        <el-button type="text" @click="seeDetail()">查看详情</el-button>-->
<!--                    </div>-->
<!--                    <span slot="reference">{{ searchForm.resourcesName }}</span>-->
<!--                </el-popover>-->
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
        </div>
        <resource-add-edit-form ref="resourceAddEditForm"></resource-add-edit-form>
    </el-dialog>
</template>

<script>
import ResourceAddEditForm from "@/views/modules/dyygCollect/library/resourceAddEditForm.vue";

export default {
    name: "editMark",
    components: {ResourceAddEditForm},
    data() {
        return {
            title: '修改标注',
            visible: false,
            searchForm: {
                id: '',
                labelName: '',
                createDate: '',
                labeState: '',
                resourcesName: '',
                auditId:'',

                resourcesId:'',
                basicDataId:'',
            },
            rules: {
                labelName: [
                    {required: true, message: '请填写标注名称', trigger: 'blur'}
                ]
            },
        }
    },

    methods: {
        //type add新增 edit编辑
        init(type, row) {
            this.searchForm.id = ''
            if (type == 'edit') {
                this.title = '修改标注'
            }
            this.visible = true
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            this.getDetail(row.middleId)
        },

        //获取信息
        getDetail(id) {
            this.$axios(this.api.academic.resourceslabelGetById + id).then(data => {
                if (data && data.status) {
                    this.searchForm = data.data
                }
            })
        },

        //详情 typeName view详情 edit编辑 toExamineView审核详情
        view() {
            this.$refs.resourceAddEditForm.init('view', this.searchForm.resourcesId, '', this.searchForm.basicDataId,'',this.searchForm)
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    this.$axios(this.api.academic.resourceslabelUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        }
                    )
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}
</style>